import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1xs2,
    GridItem3,
    GridItem4xs9,
    GridItem4xs10,
} from '../../../business-components/Grid/Grid'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadraoRequired,
} from '../../../business-components/MuiPickers/MuiPickers'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonAlterarCenario,
    ButtonExcluirCenario,
    ButtonConfiguracoesAdicionais,
} from '../../../business-components/Button/Button'

import {
    SvgImageBoletimFocus
} from '../../../business-components/SvgImage/SvgImage'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    incluirCenario,
    excluirCenario,
    informarCenarioPrincipal,
} from './EstudoServiceCenarios'

import {
    urlBoletimFocus,
} from './EstudoServiceCenariosTaxas'



export const BoletimFocus = () => {

    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={urlBoletimFocus()}
        >
            <SvgImageBoletimFocus />
        </a>
    )
}



export const ButtonIncluirCenarios = ({ values, setFieldValue, simulacaoFinanceira }) => {

    return (
        <ButtonIncluirLinha
            label={LABEL.buttonIncluirCenario}
            //type="submit"
            align={simulacaoFinanceira ? 'center' : IsXsDownScreen() ? "left" : "right"}
            onClick={() => {
                incluirCenario(values)
                setFieldValue(
                    "cenarioAtual",
                    values.cenarioAtual
                )
            }}
        />
    )
}

export const ButtonAlterarCenarios = ({ values, handleChange, setFieldValue } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='md'
            popupTitle={LABEL.buttonAlterarCenario}
            PopupButton={ButtonAlterarCenario}
            popupComponent={
                <Cenarios
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                />
            }
        />
    )
}

export const ButtonExcluirCenarios = ({ values, setFieldValue }) => {

    return (
        <ButtonExcluirCenario
            //type="submit"
            onClick={() => {
                excluirCenario(values)
                setFieldValue(
                    "cenarioAtual",
                    values.cenarioAtual
                )
            }}
        />
    )
}

export const IconButtonExcluirCenarios = ({ values, setFieldValue }) => {

    return (
        values.cenarios.length > 1
            ?
                <IconButtonClearEntradaDados
                    //type="submit"
                    align="left"
                    className='mt-2'
                    onClick={() => {
                        excluirCenario(values)
                        setFieldValue(
                            "cenarioAtual",
                            values.cenarioAtual
                        )
                    }}
                />
            :
                ''
    )
}

export const DataSimulacaoEstudo = ({ values, setFieldValue }) => {

    return (
        <MuiPickersUtilsProviderPadrao>
            <KeyboardDatePickerPadraoRequired
                name="dataSimulacaoEstudo"
                label={LABEL.dataSimulacaoEstudo}
                value={values.dataSimulacaoEstudo}
                onChange={(date) => {
                    setFieldValue(
                        'dataSimulacaoEstudo',
                        date,
                    )}
                }
            />
        </MuiPickersUtilsProviderPadrao>
    )
}

export const Cenarios = ({ values, handleChange, setFieldValue }) => {

    if (!values.naoExibirComparacaoCenarios || values.cenarioPrincipal === values.cenarioAtual) {

        values.naoExibirComparacaoCenarios = false
    }

    return (
        <>
            <GridContainer>
                <GridItem4xs10>
                    <TextValidatorText
                        name="descricaoCenario"
                        label={LABEL.cenario}
                        value={values.descricaoCenario || ''}
                        onChange={handleChange}
                        tamMax={TAMMAX.descricaoCenario}
                        notToUpperCase={true}
                    />
                </GridItem4xs10>

                <GridItem1xs2>
                    <IconButtonExcluirCenarios
                        values={values}
                        setFieldValue={setFieldValue}
                    />
                </GridItem1xs2>

                <GridItem4xs9
                    className='mt--1'
                >
                    <ButtonIncluirCenarios
                        values={values}
                        setFieldValue={setFieldValue}
                    />
                </GridItem4xs9>

                <GridItem3>
                    <BoletimFocus />
                </GridItem3>
            </GridContainer>

            <GridContainer>
                <GridItem4xs10>
                    <DataSimulacaoEstudo
                        values={values}
                        setFieldValue={setFieldValue}
                    />
                </GridItem4xs10>

                <GridItem1xs2/>

                {informarCenarioPrincipal(values) && (
                    <GridItem4xs9>
                        <CustomizedDialogsPopup
                            maxWidth='md'
                            popupTitle={LABEL.buttonConfiguracoesAdicionais}
                            PopupButton={ButtonConfiguracoesAdicionais}
                            popupComponent={
                                <>
                                    <TextFieldNumberSelectRequired
                                        name={"cenarioPrincipal"}
                                        label={LABEL.cenarioPrincipal.replace('$1$', values.versao)}
                                        value={values.cenarioPrincipal || ''}
                                        onChange={handleChange}
                                        list={values.cenarios}
                                    />

                                    <CheckboxPadrao
                                        name="naoExibirComparacaoCenarios"
                                        label={LABEL.naoExibirComparacaoCenarios}
                                        checked={values.naoExibirComparacaoCenarios}
                                        onChange={handleChange}
                                        disabled={values.cenarioPrincipal === values.cenarioAtual}
                                    />
                                </>
                            }
                        />
                    </GridItem4xs9>
                )}
            </GridContainer>
            
        </>
    )
}